import t from "./chunk919.js";
import m from "./chunk1145.js";
const r = t();
function u(e = r) {
  return m(e);
}
export {
  u as default,
  r as systemDefaultTheme
};
